
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResultModalData, showModal, showNestedModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";
import { setTopPagesMapAllShipmentCurrentLocationList, setTopPagesMapAllTamamlananShipmentCurrentLocationList } from "../topPagesMap/topPagesMapSlice";
import { getTopPagesNotificationsCounts } from "../notification/notificationSlice";
import { toastApiError } from "../../helper/api/toastApiError";
import { getShipmentCollection } from "../../helper/shipment/safeShipmentListItem";

const initialState = {

    //! yükler listesi
    isLoadingGetLoadlist: false,
    loadList: [],
    loadListQuantity: null,
    // teklif vere bastığımız zaman yakaladığımız id
    loadItemSelect:null,

    selectLoadItem: null,

    selectedAspiredLoadId: null,

    //! toplu yük listesi
    loadBulkList: [],

    //! adminde bulunan şirket filtreleme
    loadListCompanyList: [],
    selectedLoadListCompany: [],

    //! teklifler listesi
    tekliflerList: [],
    tekliflerListQuantity: null, 
    isLoadingGetTekliflerList: false,
    selectAspiredLoadItem: null,

    //! teklif kabul
    isLoadingTeklifKabul: false,

    //! teklif red
    isLoadingTeklifRed: false,

    //! sürücü onayinda listesi
    surucuOnayindaList: [],
    surucuOnayindaListQuantity: null,
    isLoadingGetSurucuOnayindaList: null,

    //! atananlar listesi
    atananlarList: [],
    atananlarListQuantity: null,
    isLoadingAtananlarList: false,

    //! yuklemede list
    yuklemedeList: [],
    yuklemedeListQuantity: null,
    isLoadingYuklemedeList: false,

    //! seferde List
    seferdeList: [],
    seferdeListQuantity: null,
    seferdeLocationList: [],
    isLoadingSeferdeList: false,

    //! bosaltmadalist
    bosaltmadaList: [],
    bosaltmadaListQuantity: null,
    bosaltmadaLocationList: [],
    isLoadingBosaltmadaList: false,

    //! sevkiyat tamamlama
    isLoadingCompleteShipments: false,
    completeShipmentIds: [],

    //! konteyner ve mühür numarası güncelleme
    isLoadingUpdateShipmentContainerAndSealNumbers: false,
    shipmentContainerAndSealData: null,

    //! sevkiyat silme ve sürücü/araç değiştirme
    shipmentActionData: null,
    isLoadingDeleteShipment: false,
    shipmentVehicleOptions: null,
    shipmentVehicleOptionsError: null,
    isLoadingShipmentVehicleOptions: false,
    isLoadingUpdateShipmentVehicle: false,

    //! tamamlanan seferler list
    tamamlananSeferlerList: [],
    tamamlananSeferlerListQuantity: null,
    isLoadingTamamlananSeferlerList: false, 

    //! delete load
    isLoadingDeleteLoad: false,

    //! update Route data
    isLoadingUpdateRouteData: false,

    //! loadItemData
    loadItemData: null,

    searchCompanyNameList: null,
    allCompanyList: [],

    belgeData: [],

    belgeDataSingleItem: null,

    isError: false,

    processedUserId: null,

    isLoadingSearch: false,
    isErrorSearch: false,

    //! singleShipmentLoadItem
    isLoadingGetSingleShipmentLoadItem: false,
    singleShipmentLoadItem: null,
    singleShipmentLoadItemError: null,


}

//! yükler listesi
export const getLoadList = createAsyncThunk("loadList/getLoadList", async({currentPage, loadCity="", unLoadCity="", isParsiyel=0, companyName="", loadDate="",truckType="", publishingTypeId="", orderBy, orderDirection}, thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.get(`/Load/GetLoadFilter?Page=${currentPage}&&StatusOfAspiredLoad=${0}&&LoadCity=${loadCity}&&UnLoadCity=${unLoadCity}${isParsiyel ? `&&IsParsiyel=${isParsiyel}` : ""}&&CompanyName=${companyName}&&LoadDate=${loadDate}&&TruckType=${truckType}${publishingTypeId ? `&&PublishingTypeId=${publishingTypeId}` : ""}${orderBy ? `&&orderBy=${orderBy}` : ""}${orderDirection ? `&&orderDirection=${orderDirection}` : ""}`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! yükler listesi admin için
export const getLoadListAdmin = createAsyncThunk("loadList/getLoadListAdmin", async({currentPage, loadCity="", unLoadCity="", isParsiyel=0, companyName="", loadDate="",truckType="", publishingTypeId="", orderBy, orderDirection, companyList}, thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.get(`/Load/GetLoadFilterAdmin?Page=${currentPage}&&StatusOfAspiredLoad=${0}&&LoadCity=${loadCity}&&UnLoadCity=${unLoadCity}${isParsiyel ? `&&IsParsiyel=${isParsiyel}` : ""}&&CompanyName=${companyName}&&LoadDate=${loadDate}&&TruckType=${truckType}${publishingTypeId ? `&&PublishingTypeId=${publishingTypeId}` : ""}${orderBy ? `&&orderBy=${orderBy}` : ""}${orderDirection ? `&&orderDirection=${orderDirection}` : ""}${companyList?.length > 0 ? `&&CompanyId=${companyList?.map(company => company?.id).join('&&CompanyId=')}` : ""}`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const deleteLoad = createAsyncThunk("loadList/deleteLoad", async(body,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Load/DeleteNew`, body)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Yük kaydı başarıyla Silindi", resultType: "success", btnText1: "Listeyi Görüntüle"}))
            return data
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", btnText1: "Listeyi Görüntüle"}))
        }

    } catch (error) {
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin",resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

//! teklifler listesi
export const getTekliflerList = createAsyncThunk("loadList/getTekliflerList", async({currentPage, loadCity="", unLoadCity="", isParsiyel=0, companyName="", loadDate="",truckType="", publishingTypeId="", orderBy, orderDirection, aspiredFilter}, thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/Load/GetLoadFilter?Page=${currentPage}&&StatusOfAspiredLoad=${1}&&LoadCity=${loadCity}&&UnLoadCity=${unLoadCity}${isParsiyel ? `&&IsParsiyel=${isParsiyel}` : ""}&&CompanyName=${companyName}&&LoadDate=${loadDate}&&TruckType=${truckType}${publishingTypeId ? `&&PublishingTypeId=${publishingTypeId}` : ""}${orderBy ? `&&orderBy=${orderBy}` : ""}${orderDirection ? `&&orderDirection=${orderDirection}` : ""}${aspiredFilter.value !== null ? `&&IsAspireApproved=${aspiredFilter.id}` : ""}`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! teklifler listesi admin
export const getTekliflerListAdmin = createAsyncThunk("loadList/getTekliflerListAdmin", async({currentPage, loadCity="", unLoadCity="", isParsiyel=0, companyName="", loadDate="",truckType="", publishingTypeId="", orderBy, orderDirection, aspiredFilter, companyList}, thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/Load/GetLoadFilterAdmin?Page=${currentPage}&&StatusOfAspiredLoad=${1}&&LoadCity=${loadCity}&&UnLoadCity=${unLoadCity}${isParsiyel ? `&&IsParsiyel=${isParsiyel}` : ""}&&CompanyName=${companyName}&&LoadDate=${loadDate}&&TruckType=${truckType}${publishingTypeId ? `&&PublishingTypeId=${publishingTypeId}` : ""}${orderBy ? `&&orderBy=${orderBy}` : ""}${orderDirection ? `&&orderDirection=${orderDirection}` : ""}${aspiredFilter.value !== null ? `&&IsAspireApproved=${aspiredFilter.id}` : ""}${companyList?.length > 0 ? `&&CompanyId=${companyList?.map(company => company?.id).join('&&CompanyId=')}` : ""}`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const teklifKabul = createAsyncThunk("loadList/teklifKabul", async(rejectData,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Aspire/ApproveAspireFromWaitingLoadOwner`,rejectData)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Teklif başarıyla kabul edildi.", resultType: "success", routePath:"/atananlar",  btnText1: "Listeyi Görüntüle"}))
            // thunkApi.dispatch(getTopPagesNotificationsCounts())
            thunkApi.dispatch(getTopPagesNotificationsCounts({companyList: []}));
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


export const teklifRed = createAsyncThunk("loadList/teklifRed", async(id,thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.post(`/Aspire/RejectAspiredLoad`,id)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Teklif başarıyla reddedildi.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
            // thunkApi.dispatch(getTopPagesNotificationsCounts())
            thunkApi.dispatch(getTopPagesNotificationsCounts({companyList: []}));
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

//! sürücü onayında
export const getSurucuOnayindaList = createAsyncThunk("loadList/getSurucuOnayindaList", async({currentPage, loadCity="", unLoadCity="", isParsiyel=0, companyName="", loadDate="",truckType="", publishingTypeId="", orderBy, orderDirection}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Load/GetLoadFilter?Page=${currentPage}&&StatusOfAspiredLoad=${2}&&LoadCity=${loadCity}&&UnLoadCity=${unLoadCity}${isParsiyel ? `&&IsParsiyel=${isParsiyel}` : ""}&&CompanyName=${companyName}&&LoadDate=${loadDate}&&TruckType=${truckType}${publishingTypeId ? `&&PublishingTypeId=${publishingTypeId}` : ""}${orderBy ? `&&orderBy=${orderBy}` : ""}${orderDirection ? `&&orderDirection=${orderDirection}` : ""}`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! sürücü onayında admin
export const getSurucuOnayindaListAdmin = createAsyncThunk("loadList/getSurucuOnayindaListAdmin", async({currentPage, loadCity="", unLoadCity="", isParsiyel=0, companyName="", loadDate="",truckType="", publishingTypeId="", orderBy, orderDirection, companyList}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Load/GetLoadFilterAdmin?Page=${currentPage}&&StatusOfAspiredLoad=${2}&&LoadCity=${loadCity}&&UnLoadCity=${unLoadCity}${isParsiyel ? `&&IsParsiyel=${isParsiyel}` : ""}&&CompanyName=${companyName}&&LoadDate=${loadDate}&&TruckType=${truckType}${publishingTypeId ? `&&PublishingTypeId=${publishingTypeId}` : ""}${orderBy ? `&&orderBy=${orderBy}` : ""}${orderDirection ? `&&orderDirection=${orderDirection}` : ""}${companyList?.length > 0 ? `&&CompanyId=${companyList?.map(company => company?.id).join('&&CompanyId=')}` : ""}`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! atananlar listesi
export const getAtananlarList = createAsyncThunk("loadList/getAtananlarList", async({currentPage, loadCity="", unLoadCity="", isParsiyel, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka}, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilter?Asama=4&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}`)

        const formattedData = getShipmentCollection(data?.data?.liveLocationData?.locationList).map((item) => ({
            ...item,
            currentDriverLocation: {...item.currentDriverLocation}
        }))
        thunkApi.dispatch(setTopPagesMapAllShipmentCurrentLocationList(formattedData))

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! atananlar listesi admin
export const getAtananlarListAdmin = createAsyncThunk("loadList/getAtananlarListAdmin", async({currentPage, loadCity="", unLoadCity="", isParsiyel, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka, companyList}, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilterAdmin?Asama=4&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}${companyList?.length > 0 ? `&&CompanyId=${companyList?.map(company => company?.id).join('&&CompanyId=')}` : ""}`)

        const formattedData = getShipmentCollection(data?.data?.liveLocationData?.locationList).map((item) => ({
            ...item,
            currentDriverLocation: {...item.currentDriverLocation}
        }))
        thunkApi.dispatch(setTopPagesMapAllShipmentCurrentLocationList(formattedData))

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! yuklemede listesi
export const getYuklemedeList = createAsyncThunk("loadList/getYuklemedeList", async({currentPage, loadCity="", unLoadCity="", isParsiyel, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilter?Asama=${0}&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}`)
      
        const formattedData = data.data.liveLocationData.locationList.$values.map((item) => {
            return {
                ...item,
                currentDriverLocation: {
                    ...item.currentDriverLocation,
                    // createdDate: addThreeHoursToISO(item.currentDriverLocation.createdDate)
                }
            }
        })
        thunkApi.dispatch(setTopPagesMapAllShipmentCurrentLocationList(formattedData))
        

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! yuklemede listesi admin
export const getYuklemedeListAdmin = createAsyncThunk("loadList/getYuklemedeListAdmin", async({currentPage, loadCity="", unLoadCity="", isParsiyel, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka, companyList}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilterAdmin?Asama=${0}&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}${companyList?.length > 0 ? `&&CompanyId=${companyList?.map(company => company?.id).join('&&CompanyId=')}` : ""}`)

        const formattedData = data.data.liveLocationData.locationList.$values.map((item) => {
            return {
                ...item,
                currentDriverLocation: {
                    ...item.currentDriverLocation,
                    // createdDate: addThreeHoursToISO(item.currentDriverLocation.createdDate)
                }
            }
        })
        thunkApi.dispatch(setTopPagesMapAllShipmentCurrentLocationList(formattedData))
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! seferde listesi
export const getSeferdeList = createAsyncThunk("loadList/getSeferdeList", async({currentPage, loadCity="", unLoadCity="", isParsiyel, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka}, thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilter?Asama=${1}&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}`)
        
        const formattedData = data.data.liveLocationData.locationList.$values.map((item) => {
            return {
                ...item,
                currentDriverLocation: {
                    ...item.currentDriverLocation,
                    // createdDate: addThreeHoursToISO(item.currentDriverLocation.createdDate)
                }
            }
        })
        thunkApi.dispatch(setTopPagesMapAllShipmentCurrentLocationList(formattedData))
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! seferde listesi admin
export const getSeferdeListAdmin = createAsyncThunk("loadList/getSeferdeListAdmin", async({currentPage, loadCity="", unLoadCity="", isParsiyel, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka, companyList}, thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilterAdmin?Asama=${1}&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}${companyList?.length > 0 ? `&&CompanyId=${companyList?.map(company => company?.id).join('&&CompanyId=')}` : ""}`)
        
        const formattedData = data.data.liveLocationData.locationList.$values.map((item) => {
            return {
                ...item,
                currentDriverLocation: {
                    ...item.currentDriverLocation,
                    // createdDate: addThreeHoursToISO(item.currentDriverLocation.createdDate)
                }
            }
        })
        thunkApi.dispatch(setTopPagesMapAllShipmentCurrentLocationList(formattedData))
               
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! boşaltma listesi
export const getBosaltmadaList = createAsyncThunk("loadList/getBosaltmadaList", async({currentPage, loadCity="", unLoadCity="", isParsiyel=null, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilter?Asama=${2}&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}`)

        const formattedData = data.data.liveLocationData.locationList.$values.map((item) => {
            return {
                ...item,
                currentDriverLocation: {
                    ...item.currentDriverLocation,
                    // createdDate: addThreeHoursToISO(item.currentDriverLocation.createdDate)
                }
            }
        })
        thunkApi.dispatch(setTopPagesMapAllShipmentCurrentLocationList(formattedData))

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! boşaltma listesi admin
export const getBosaltmadaListAdmin = createAsyncThunk("loadList/getBosaltmadaListAdmin", async({currentPage, loadCity="", unLoadCity="", isParsiyel=null, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka, companyList}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilterAdmin?Asama=${2}&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}${companyList?.length > 0 ? `&&CompanyId=${companyList?.map(company => company?.id).join('&&CompanyId=')}` : ""}`)

        const formattedData = data.data.liveLocationData.locationList.$values.map((item) => {
            return {
                ...item,
                currentDriverLocation: {
                    ...item.currentDriverLocation,
                    // createdDate: addThreeHoursToISO(item.currentDriverLocation.createdDate)
                }
            }
        })
        thunkApi.dispatch(setTopPagesMapAllShipmentCurrentLocationList(formattedData))
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! tamamlanan seferler
export const getTamamlananSeferler = createAsyncThunk("loadList/getTamamlananSeferler", async({currentPage, loadCity="", unLoadCity="", isParsiyel=null, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilter?Asama=${3}&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}`)

        const formattedData = data.data.liveLocationData.locationList.$values.map((item) => {
            return {
                ...item,
                currentDriverLocation: {
                    ...item.currentDriverLocation,
                    // createdDate: addThreeHoursToISO(item.currentDriverLocation.createdDate)
                }
            }
        })
        thunkApi.dispatch(setTopPagesMapAllTamamlananShipmentCurrentLocationList(formattedData))

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! tamamlanan seferler admin
export const getTamamlananSeferlerAdmin = createAsyncThunk("loadList/getTamamlananSeferlerAdmin", async({currentPage, loadCity="", unLoadCity="", isParsiyel=null, loadDate="",truckType="", gonderici="", alici="", orderBy, orderDirection, aracPlaka, companyList}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentFilterAdmin?Asama=${3}&&Sayi=${currentPage}&&gondericiCity=${loadCity}&&aliciCity=${unLoadCity}${(isParsiyel === true || isParsiyel === false) ? `&&IsParsiyel=${isParsiyel}`: ""}&&gonderici=${gonderici}&&alici=${alici}&&loadDate=${loadDate}&&truckType=${truckType}&&orderBy=${orderBy}&&orderDirection=${orderDirection}&&aracPlaka=${aracPlaka}${companyList?.length > 0 ? `&&CompanyId=${companyList?.map(company => company?.id).join('&&CompanyId=')}` : ""}`)

        const formattedData = data.data.liveLocationData.locationList.$values.map((item) => {
            return {
                ...item,
                currentDriverLocation: {
                    ...item.currentDriverLocation,
                    // createdDate: addThreeHoursToISO(item.currentDriverLocation.createdDate)
                }
            }
        })
        thunkApi.dispatch(setTopPagesMapAllTamamlananShipmentCurrentLocationList(formattedData))

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const completeShipments = createAsyncThunk("loadList/completeShipments", async(body, thunkApi)=> {
    try {
        const shipmentIds = Array.isArray(body?.shipmentIds) ? body.shipmentIds : []
        const {data} = await axiosInstance.post(`/Shipment/CompleteShipments`, {shipmentIds})

        if (data?.statusCode !== undefined && (data.statusCode < 200 || data.statusCode >= 300)) {
            const message = toastApiError(data, "Sevkiyat tamamlama işlemi gerçekleştirilemedi.")
            return thunkApi.rejectWithValue({message, status: data.statusCode})
        }

        thunkApi.dispatch(setResultModalData({
            msg: shipmentIds.length > 1 ? "Seçili sevkiyatlar başarıyla tamamlandı." : "Sevkiyat başarıyla tamamlandı.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle"
        }))
        thunkApi.dispatch(showModal("result"))

        return {data, shipmentIds}
    } catch (error) {
        const message = toastApiError(error, "Sevkiyat tamamlama işlemi gerçekleştirilemedi.")
        return thunkApi.rejectWithValue({message, status: error?.response?.status ?? null})
    }
})

export const updateShipmentContainerAndSealNumbers = createAsyncThunk(
    "loadList/updateShipmentContainerAndSealNumbers",
    async(body, thunkApi)=> {
        try {
            const requestBody = {
                shipmentId: body?.shipmentId,
                containerNumber: body?.containerNumber ?? "",
                sealNumber: body?.sealNumber ?? ""
            }
            const {data} = await axiosInstance.post(`/Shipment/UpdateShipmentContainerAndSealNumbers`, requestBody)

            if (data?.statusCode !== undefined && (data.statusCode < 200 || data.statusCode >= 300)) {
                const message = toastApiError(data, "Konteyner ve mühür numarası güncellenemedi.")
                return thunkApi.rejectWithValue({message, status: data.statusCode})
            }

            thunkApi.dispatch(setResultModalData({
                msg: "Konteyner ve mühür numarası başarıyla güncellendi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle"
            }))
            thunkApi.dispatch(showModal("result"))

            return requestBody
        } catch (error) {
            const message = toastApiError(error, "Konteyner ve mühür numarası güncellenemedi.")
            return thunkApi.rejectWithValue({message, status: error?.response?.status ?? null})
        }
    }
)

export const deleteShipment = createAsyncThunk("loadList/deleteShipment", async(shipmentId, thunkApi) => {
    try {
        const {data} = await axiosInstance.post(`/Shipment/DeleteShipmentV1`, {shipmentId})
        if (data?.statusCode !== undefined && (data.statusCode < 200 || data.statusCode >= 300)) {
            const message = toastApiError(data, "Sevkiyat silinemedi.")
            return thunkApi.rejectWithValue({message, status: data.statusCode})
        }

        thunkApi.dispatch(setResultModalData({
            msg: "Sevkiyat kalıcı olarak silindi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle"
        }))
        thunkApi.dispatch(showModal("result"))
        return {shipmentId}
    } catch (error) {
        const message = toastApiError(error, "Sevkiyat silinemedi.")
        return thunkApi.rejectWithValue({message, status: error?.response?.status ?? null})
    }
})

export const getShipmentVehicleOptions = createAsyncThunk("loadList/getShipmentVehicleOptions", async(shipmentId, thunkApi) => {
    try {
        const {data} = await axiosInstance.post(`/Shipment/GetShipmentVehicleOptionsV1`, {shipmentId})
        if (data?.statusCode !== undefined && (data.statusCode < 200 || data.statusCode >= 300)) {
            const message = toastApiError(data, "Sürücü ve araç seçenekleri alınamadı.")
            return thunkApi.rejectWithValue({message, status: data.statusCode})
        }
        return data?.data ?? data
    } catch (error) {
        const message = toastApiError(error, "Sürücü ve araç seçenekleri alınamadı.")
        return thunkApi.rejectWithValue({message, status: error?.response?.status ?? null})
    }
})

export const updateShipmentVehicle = createAsyncThunk("loadList/updateShipmentVehicle", async(body, thunkApi) => {
    try {
        const requestBody = {shipmentId: body.shipmentId}
        if (body.driverDevamliAraclarId !== "" && body.driverDevamliAraclarId !== null && body.driverDevamliAraclarId !== undefined) {
            requestBody.driverDevamliAraclarId = Number(body.driverDevamliAraclarId)
        }
        if (body.truckId !== "" && body.truckId !== null && body.truckId !== undefined) requestBody.truckId = Number(body.truckId)
        if (body.trailerId !== "" && body.trailerId !== null && body.trailerId !== undefined) requestBody.trailerId = Number(body.trailerId)

        const {data} = await axiosInstance.post(`/Shipment/UpdateShipmentVehicleV1`, requestBody)
        if (data?.statusCode !== undefined && (data.statusCode < 200 || data.statusCode >= 300)) {
            const message = toastApiError(data, "Sevkiyatın sürücü ve araç bilgileri güncellenemedi.")
            return thunkApi.rejectWithValue({message, status: data.statusCode})
        }

        thunkApi.dispatch(setResultModalData({
            msg: "Sevkiyatın sürücü ve araç bilgileri güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle"
        }))
        thunkApi.dispatch(showModal("result"))
        return {shipmentId: body.shipmentId, response: data?.data, viewData: body.viewData ?? {}}
    } catch (error) {
        const message = toastApiError(error, "Sevkiyatın sürücü ve araç bilgileri güncellenemedi.")
        return thunkApi.rejectWithValue({message, status: error?.response?.status ?? null})
    }
})




//! bu gönderici alici bilgileri için
export const updateRouteData = createAsyncThunk("loadList/updateRouteData", async(routeData, thunkApi)=> {
    try {

        const {data} = await axiosInstance.post(`${process.env.REACT_APP_API_URI}/RoutePoints/Update`, routeData)


        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Yetkili Bilgileri başarıyla güncellendi. ", resultType: "success", btnText1: "Listeyi Görüntüle"}))
            thunkApi.dispatch(updateLoadItem(data.data))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", routePath: "/yukler-listesi" ,resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


//! bu o sırada sayfada olmasa bile location bilgisinin haritada gösterilmesi için
export const getSingleShipmentLoadItem = createAsyncThunk("loadList/getSingleShipmentLoadItem", async(shipmentId, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Shipment/GetShipmentById`, {
            params: { id: shipmentId }
        })
        
        return data
    } catch (error) {
        const message = toastApiError(error, "Sevkiyat detayı alınamadı.")
        return thunkApi.rejectWithValue({ message, status: error?.response?.status ?? null })
    }
})

export const surucuyuDegerlendir = createAsyncThunk("loadList/surucuyuDegerlendir", async(degerlendirme,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Shipment/AddRateAndCommentToUserForShipmentFromUser`, degerlendirme)

        if(data.statusCode === 200){
            thunkApi.dispatch(showNestedModal(null))
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Sürücü başarıyla değerlendirildi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! yükler listesi company

export const getAdminCompanyLoadFilter = createAsyncThunk("loadList/getAdminCompanyLoadFilter", async(body,thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/load/GetAdminCompanyLoadFilter`, body)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


const loadListSlice = createSlice({
    name: "loadList",
    initialState,
    reducers: {
        //! teklifler sayfasına yönlenecek ürünün idsi
        setLoadItemSelect:(state,action)=>{
            state.loadItemSelect = action.payload
        },

        setSelectedAspiredLoadId:(state,action)=>{
            state.selectedAspiredLoadId = action.payload
        },

        setLoadItemData: (state, action) => {
            state.loadItemData = action.payload
        },

        setCompleteShipmentIds: (state, action) => {
            state.completeShipmentIds = Array.isArray(action.payload) ? action.payload : []
        },

        setShipmentContainerAndSealData: (state, action) => {
            state.shipmentContainerAndSealData = action.payload ?? null
        },

        setShipmentActionData: (state, action) => {
            state.shipmentActionData = action.payload ?? null
        },

        resetShipmentVehicleOptions: (state) => {
            state.shipmentVehicleOptions = null
            state.shipmentVehicleOptionsError = null
        },

        updateLoadItem: (state, action) => {
            state.loadList = state.loadList.map((item) => {
                if(item.id === action.payload.id){
                    return action.payload
                }
                else{
                    return item
                }
            })
        },

        //! yükler listesinde yayınlama seçeneği değiştirince response
        updateLoadItemForPublishing: (state, action) => {
            state.loadList = state.loadList.map((item) => {
                if(item.id === action.payload.id){
                    return {...item, publishingTypeId: action.payload.publishingTypeId, scheduledPublishTime: action.payload.scheduledPublishTime}
                }
                else{
                    return item
                }
            })
        },

        //! bu jobList de eşleştirme yapılınca silinmesi için
        deleteSingleLoadItem: (state, action) => {
            state.loadList = state.loadList.filter(item => item.id !== action.payload)
        },

        getBelgeData: (state, action) => {
            state.belgeData = action.payload
        },
        getBelgeDataSingleItem: (state, action) => {
            state.belgeDataSingleItem = action.payload
        },

        setTeklifUserId: (state, action) => {
            state.processedUserId = action.payload
        },

        setTopluYukErrorMessage:(state, action) => {
            state.topluYukErrorMessage = action.payload
        },

        setTopluYukSuccessMessage:(state, action) => {
            state.topluYukSuccessMessage = action.payload
        },

        //! burası bildirim gelince ilgili item ın renkliliğini giermek için tıklama olduğunda
        setTopPagesItemNotificationClicked: (state, action) => {
            const {type, id} = action.payload
            
            //! teklif
            if(type === "teklif"){
                state.tekliflerList = state.tekliflerList.map(item => {
                    if(item.id === id){
                        return {...item, notificationType:0}
                    }
                    return item
                })
            }

            //! atananlar
            if(type === "atananlar"){
                state.atananlarList = state.atananlarList.map(item => {
                    if(item.id === id){
                        return{...item, waitinLoad: {...item.waitinLoad, notificationType: 0}}
                    }
                    return item
                })
            }

            //! yukleme
            if(type === "yukleme"){
                state.yuklemedeList = state.yuklemedeList.map(item => {
                    if(item.id === id){
                        return{...item, waitinLoad: {...item.waitinLoad, notificationType: 0}}
                    }
                    return item
                })
            }

            //! sefer
            if(type === "sefer"){
                state.seferdeList = state.seferdeList.map(item => {
                    if(item.id === id){
                        return{...item, waitinLoad: {...item.waitinLoad, notificationType: 0}}
                    }
                    return item
                })
            }
            
            //! bosaltma
            if(type === "bosaltma"){
                state.bosaltmadaList = state.bosaltmadaList.map(item => {
                    if(item.id === id){
                        return{...item, waitinLoad: {...item.waitinLoad, notificationType: 0}}
                    }
                    return item
                })
            }

            //! tamamlanan
            if(type === "tamamlanan"){
                state.tamamlananSeferlerList = state.tamamlananSeferlerList.map(item => {
                    if(item.id === id){
                        return{...item, waitinLoad: {...item.waitinLoad, notificationType: 0}}
                    }
                    return item
                })
            }
        },

        setShipmentData: (state, action) => {
            state.shipmentData = action.payload
        },

        setSelectedLoadListCompany: (state, action) => {
            state.selectedLoadListCompany = action.payload
        },


        //! ShipmentOperation güncellemelerini atananlar ve yüklemede listelerine yansıtmak için
        updateYuklemedeListForShipmentOperation: (state, action) => {
            const updateShipment = (item) => {
                if(item.id === action.payload.id){
                    return action.payload
                }
                return item
            }
            state.atananlarList = state.atananlarList.map(updateShipment)
            state.yuklemedeList = state.yuklemedeList.map(updateShipment)
        },

        resetSingleShipmentLoadItem: (state) => {
            state.singleShipmentLoadItem = null
            state.singleShipmentLoadItemError = null
        },

    },
    extraReducers:(builder)=> {
        builder

        //! get Load List
        .addCase(getLoadList.pending, (state)=> {
            state.isLoadingGetLoadlist = true
        })
        .addCase(getLoadList.fulfilled, (state, action)=> {
            state.isLoadingGetLoadlist = false
            state.loadList = getShipmentCollection(action.payload?.items)
            state.loadListQuantity = action.payload?.count ?? 0
            
        })
        .addCase(getLoadList.rejected, (state, action)=> {
            state.isLoadingGetLoadlist = false
            state.isError = true
        })
        //! get load list admin
        
        .addCase(getLoadListAdmin.pending, (state)=> {
            state.isLoadingGetLoadlist = true
        })
        .addCase(getLoadListAdmin.fulfilled, (state, action)=> {
            state.isLoadingGetLoadlist = false
            state.loadList = getShipmentCollection(action.payload?.items)
            state.loadListQuantity = action.payload?.count ?? 0
            
        })
        .addCase(getLoadListAdmin.rejected, (state, action)=> {
            state.isLoadingGetLoadlist = false
            state.isError = true
        })

        //! delete Load List
        .addCase(deleteLoad.pending, (state)=> {
            state.isLoadingDeleteLoad = true
        })
        .addCase(deleteLoad.fulfilled, (state, action)=> {
            state.isLoadingDeleteLoad = false
            state.loadList = state.loadList.filter((item) => {
                return item.id !== action.payload.data.id 
            })
            state.loadListQuantity = state.loadListQuantity -1
        })
        .addCase(deleteLoad.rejected, (state, action)=> {
            state.isLoadingDeleteLoad = false
            state.isError = true
        })

        //! get teklifler List
        .addCase(getTekliflerList.pending, (state)=> {
            state.isLoadingGetTekliflerList = true
        })
        .addCase(getTekliflerList.fulfilled, (state, action)=> {
            state.isLoadingGetTekliflerList = false
            state.tekliflerList = action.payload.items.$values
            state.tekliflerListQuantity = action.payload.count
            
        })
        .addCase(getTekliflerList.rejected, (state, action)=> {
            state.isLoadingGetTekliflerList = false
            state.isError = true
        })
        //! get teklifler List admin
        .addCase(getTekliflerListAdmin.pending, (state)=> {
            state.isLoadingGetTekliflerList = true
        })
        .addCase(getTekliflerListAdmin.fulfilled, (state, action)=> {
            state.isLoadingGetTekliflerList = false
            state.tekliflerList = action.payload.items.$values
            state.tekliflerListQuantity = action.payload.count
            
        })
        .addCase(getTekliflerListAdmin.rejected, (state, action)=> {
            state.isLoadingGetTekliflerList = false
            state.isError = true
        })
        

        //! teklif Kabul
        .addCase(teklifKabul.pending, (state)=> {
            state.isLoadingTeklifKabul = true
        })
        .addCase(teklifKabul.fulfilled, (state, action)=> {
            state.isLoadingTeklifKabul = false
            state.tekliflerList = state.tekliflerList.map(item => {
                if(item.id === action.payload.data.$values[0].id){
                    return action.payload.data.$values[0]
                }
                else{
                    return item
                }
            } )
        })
        .addCase(teklifKabul.rejected, (state, action)=> {
            state.isLoadingTeklifKabul = false
            state.isError = true
        })

        //! teklif red
        .addCase(teklifRed.pending, (state)=> {
            state.isLoadingTeklifRed = true
        })
        .addCase(teklifRed.fulfilled, (state, action)=> {
            state.isLoadingTeklifRed = false
            state.tekliflerList = state.tekliflerList.map(item => {
                if(item.id === action.payload.data.$values[0].id){
                    return action.payload.data.$values[0]
                }
                else{
                    return item
                }
            } )
        })
        .addCase(teklifRed.rejected, (state, action)=> {
            state.isLoadingTeklifRed = false
            state.isError = true
        })

        //! get surucu onayinda List
        .addCase(getSurucuOnayindaList.pending, (state)=> {
            state.isLoadingGetSurucuOnayindaList = true
        })
        .addCase(getSurucuOnayindaList.fulfilled, (state, action)=> {
            state.isLoadingGetSurucuOnayindaList = false
            state.surucuOnayindaList = action.payload.items.$values
            state.tekliflerListQuantity = action.payload.count
        })
        .addCase(getSurucuOnayindaList.rejected, (state, action)=> {
            state.isLoadingGetSurucuOnayindaList = false
            state.isError = true
        })
        //! get surucu onayinda List admin
        .addCase(getSurucuOnayindaListAdmin.pending, (state)=> {
            state.isLoadingGetSurucuOnayindaList = true
        })
        .addCase(getSurucuOnayindaListAdmin.fulfilled, (state, action)=> {
            state.isLoadingGetSurucuOnayindaList = false
            state.surucuOnayindaList = action.payload.items.$values
            state.tekliflerListQuantity = action.payload.count
        })
        .addCase(getSurucuOnayindaListAdmin.rejected, (state, action)=> {
            state.isLoadingGetSurucuOnayindaList = false
            state.isError = true
        })

        //! get atananlar listesi
        .addCase(getAtananlarList.pending, (state)=> {
            state.isLoadingAtananlarList = true
        })
        .addCase(getAtananlarList.fulfilled, (state, action)=> {
            state.isLoadingAtananlarList = false
            state.atananlarList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.atananlarListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getAtananlarList.rejected, (state)=> {
            state.isLoadingAtananlarList = false
            state.isError = true
        })

        //! get atananlar listesi admin
        .addCase(getAtananlarListAdmin.pending, (state)=> {
            state.isLoadingAtananlarList = true
        })
        .addCase(getAtananlarListAdmin.fulfilled, (state, action)=> {
            state.isLoadingAtananlarList = false
            state.atananlarList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.atananlarListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getAtananlarListAdmin.rejected, (state)=> {
            state.isLoadingAtananlarList = false
            state.isError = true
        })
        

        //! get yuklemede List
        .addCase(getYuklemedeList.pending, (state)=> {
            state.isLoadingYuklemedeList = true
        })
        .addCase(getYuklemedeList.fulfilled, (state, action)=> {
            state.isLoadingYuklemedeList = false
            state.yuklemedeList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.yuklemedeListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getYuklemedeList.rejected, (state, action)=> {
            state.isLoadingYuklemedeList = false
            state.isError = true
        })
        //! get yuklemede List admin
        .addCase(getYuklemedeListAdmin.pending, (state)=> {
            state.isLoadingYuklemedeList = true
        })
        .addCase(getYuklemedeListAdmin.fulfilled, (state, action)=> {
            state.isLoadingYuklemedeList = false
            
            state.yuklemedeList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.yuklemedeListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getYuklemedeListAdmin.rejected, (state, action)=> {
            state.isLoadingYuklemedeList = false
            state.isError = true
        })
        

        //! get seferde List
        .addCase(getSeferdeList.pending, (state)=> {
            state.isLoadingSeferdeList = true
        })
        .addCase(getSeferdeList.fulfilled, (state, action)=> {
            
            state.isLoadingSeferdeList = false
            state.seferdeList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.seferdeListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getSeferdeList.rejected, (state, action)=> {
            state.isLoadingSeferdeList = false
            state.isError = true
        })
         //! get seferde List admin
         .addCase(getSeferdeListAdmin.pending, (state)=> {
            state.isLoadingSeferdeList = true
        })
        .addCase(getSeferdeListAdmin.fulfilled, (state, action)=> {
            
            state.isLoadingSeferdeList = false
            state.seferdeList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.seferdeListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getSeferdeListAdmin.rejected, (state, action)=> {
            state.isLoadingSeferdeList = false
            state.isError = true
        })
        

        //! get bosaltmada List
        .addCase(getBosaltmadaList.pending, (state)=> {
            state.isLoadingBosaltmadaList = true
        })
        .addCase(getBosaltmadaList.fulfilled, (state, action)=> {
            state.isLoadingBosaltmadaList = false
            state.bosaltmadaList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.bosaltmadaListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getBosaltmadaList.rejected, (state, action)=> {
            state.isLoadingBosaltmadaList = false
            state.isError = true
        })
        //! get bosaltmada List admin
        .addCase(getBosaltmadaListAdmin.pending, (state)=> {
            state.isLoadingBosaltmadaList = true
        })
        .addCase(getBosaltmadaListAdmin.fulfilled, (state, action)=> {
            state.isLoadingBosaltmadaList = false
            state.bosaltmadaList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.bosaltmadaListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getBosaltmadaListAdmin.rejected, (state, action)=> {
            state.isLoadingBosaltmadaList = false
            state.isError = true
        })

        //! sevkiyat tamamlama
        .addCase(completeShipments.pending, (state)=> {
            state.isLoadingCompleteShipments = true
        })
        .addCase(completeShipments.fulfilled, (state, action)=> {
            state.isLoadingCompleteShipments = false
            const completedIds = new Set(action.payload.shipmentIds)
            const atananlarRemovedCount = state.atananlarList.filter(item => completedIds.has(item.id)).length
            const yuklemedeRemovedCount = state.yuklemedeList.filter(item => completedIds.has(item.id)).length
            const seferdeRemovedCount = state.seferdeList.filter(item => completedIds.has(item.id)).length
            const bosaltmadaRemovedCount = state.bosaltmadaList.filter(item => completedIds.has(item.id)).length

            state.atananlarList = state.atananlarList.filter(item => !completedIds.has(item.id))
            state.yuklemedeList = state.yuklemedeList.filter(item => !completedIds.has(item.id))
            state.seferdeList = state.seferdeList.filter(item => !completedIds.has(item.id))
            state.bosaltmadaList = state.bosaltmadaList.filter(item => !completedIds.has(item.id))
            state.atananlarListQuantity = Math.max(0, (state.atananlarListQuantity ?? 0) - atananlarRemovedCount)
            state.yuklemedeListQuantity = Math.max(0, (state.yuklemedeListQuantity ?? 0) - yuklemedeRemovedCount)
            state.seferdeListQuantity = Math.max(0, (state.seferdeListQuantity ?? 0) - seferdeRemovedCount)
            state.bosaltmadaListQuantity = Math.max(0, (state.bosaltmadaListQuantity ?? 0) - bosaltmadaRemovedCount)
            state.completeShipmentIds = []
        })
        .addCase(completeShipments.rejected, (state)=> {
            state.isLoadingCompleteShipments = false
        })

        //! konteyner ve mühür numarası güncelleme
        .addCase(updateShipmentContainerAndSealNumbers.pending, (state)=> {
            state.isLoadingUpdateShipmentContainerAndSealNumbers = true
        })
        .addCase(updateShipmentContainerAndSealNumbers.fulfilled, (state, action)=> {
            state.isLoadingUpdateShipmentContainerAndSealNumbers = false
            const updatedShipment = action.payload
            const updateListItem = (item) => item.id === updatedShipment.shipmentId
                ? {
                    ...item,
                    containerNumber: updatedShipment.containerNumber,
                    sealNumber: updatedShipment.sealNumber
                }
                : item

            state.atananlarList = state.atananlarList.map(updateListItem)
            state.yuklemedeList = state.yuklemedeList.map(updateListItem)
            state.seferdeList = state.seferdeList.map(updateListItem)
            state.bosaltmadaList = state.bosaltmadaList.map(updateListItem)
            state.tamamlananSeferlerList = state.tamamlananSeferlerList.map(updateListItem)
            state.shipmentContainerAndSealData = null
        })
        .addCase(updateShipmentContainerAndSealNumbers.rejected, (state)=> {
            state.isLoadingUpdateShipmentContainerAndSealNumbers = false
        })

        //! sevkiyat silme
        .addCase(deleteShipment.pending, (state)=> {
            state.isLoadingDeleteShipment = true
        })
        .addCase(deleteShipment.fulfilled, (state, action)=> {
            state.isLoadingDeleteShipment = false
            const shipmentId = action.payload.shipmentId
            const removeShipment = (list) => list.filter(item => item.id !== shipmentId)
            const removeAndCount = (list, quantityKey) => {
                const removed = list.some(item => item.id === shipmentId)
                if (removed) state[quantityKey] = Math.max(0, (state[quantityKey] ?? 0) - 1)
                return removeShipment(list)
            }
            state.atananlarList = removeAndCount(state.atananlarList, "atananlarListQuantity")
            state.yuklemedeList = removeAndCount(state.yuklemedeList, "yuklemedeListQuantity")
            state.seferdeList = removeAndCount(state.seferdeList, "seferdeListQuantity")
            state.bosaltmadaList = removeAndCount(state.bosaltmadaList, "bosaltmadaListQuantity")
            state.tamamlananSeferlerList = removeAndCount(state.tamamlananSeferlerList, "tamamlananSeferlerListQuantity")
            state.shipmentActionData = null
        })
        .addCase(deleteShipment.rejected, (state)=> {
            state.isLoadingDeleteShipment = false
        })

        //! sevkiyat sürücü/araç seçenekleri
        .addCase(getShipmentVehicleOptions.pending, (state)=> {
            state.isLoadingShipmentVehicleOptions = true
            state.shipmentVehicleOptionsError = null
        })
        .addCase(getShipmentVehicleOptions.fulfilled, (state, action)=> {
            state.isLoadingShipmentVehicleOptions = false
            state.shipmentVehicleOptions = action.payload
        })
        .addCase(getShipmentVehicleOptions.rejected, (state, action)=> {
            state.isLoadingShipmentVehicleOptions = false
            state.shipmentVehicleOptionsError = action.payload?.message ?? "Seçenekler alınamadı."
        })

        //! sevkiyat sürücü/araç güncelleme
        .addCase(updateShipmentVehicle.pending, (state)=> {
            state.isLoadingUpdateShipmentVehicle = true
        })
        .addCase(updateShipmentVehicle.fulfilled, (state, action)=> {
            state.isLoadingUpdateShipmentVehicle = false
            const {shipmentId, response, viewData} = action.payload
            const patch = {...viewData, ...(response && typeof response === "object" ? response : {})}
            const updateShipment = (item) => item.id === shipmentId ? {...item, ...patch} : item
            state.atananlarList = state.atananlarList.map(updateShipment)
            state.yuklemedeList = state.yuklemedeList.map(updateShipment)
            state.seferdeList = state.seferdeList.map(updateShipment)
            state.bosaltmadaList = state.bosaltmadaList.map(updateShipment)
            state.shipmentActionData = null
            state.shipmentVehicleOptions = null
        })
        .addCase(updateShipmentVehicle.rejected, (state)=> {
            state.isLoadingUpdateShipmentVehicle = false
        })
        

        //! get tamamlanan seferler List
        .addCase(getTamamlananSeferler.pending, (state)=> {
            state.isLoadingTamamlananSeferlerList = true
        })
        .addCase(getTamamlananSeferler.fulfilled, (state, action)=> {
            state.isLoadingTamamlananSeferlerList = false
            state.tamamlananSeferlerList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.tamamlananSeferlerListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getTamamlananSeferler.rejected, (state, action)=> {
            state.isLoadingTamamlananSeferlerList = false
            state.isError = true
        })
        //! get tamamlanan seferler List admin
        .addCase(getTamamlananSeferlerAdmin.pending, (state)=> {
            state.isLoadingTamamlananSeferlerList = true
        })
        .addCase(getTamamlananSeferlerAdmin.fulfilled, (state, action)=> {
            state.isLoadingTamamlananSeferlerList = false
            state.tamamlananSeferlerList = getShipmentCollection(action.payload?.data?.yukListesi)
            state.tamamlananSeferlerListQuantity = action.payload?.data?.itemCount ?? 0
        })
        .addCase(getTamamlananSeferlerAdmin.rejected, (state, action)=> {
            state.isLoadingTamamlananSeferlerList = false
            state.isError = true
        })
        
        //! update Route Data
        .addCase(updateRouteData.pending, (state)=> {
            state.isLoadingUpdateRouteData = true
        })
        .addCase(updateRouteData.fulfilled, (state, action)=> {
            const updatedItem = action.payload.data.$values[0]
            state.isLoadingUpdateRouteData = false

            state.loadList = state.loadList.map((item) => {
                if(item.id === updatedItem.id){
                    return updatedItem
                }
                else{
                    return item
                }
            })
        })
        .addCase(updateRouteData.rejected, (state, action)=> {
            state.isLoadingUpdateRouteData = false
            state.isError = true
        })


        //! getSingleShipmentLoadItem
        .addCase(getSingleShipmentLoadItem.pending, (state)=> {
            state.isLoadingGetSingleShipmentLoadItem = true
            state.singleShipmentLoadItemError = null
        })
        .addCase(getSingleShipmentLoadItem.fulfilled, (state, action)=> {
            state.isLoadingGetSingleShipmentLoadItem = false
            state.singleShipmentLoadItem = action.payload
        })
        .addCase(getSingleShipmentLoadItem.rejected, (state, action)=> {
            state.isLoadingGetSingleShipmentLoadItem = false
            state.singleShipmentLoadItemError = action.payload?.message || "Sevkiyat detayı alınamadı."
        })

        //!

        .addCase(surucuyuDegerlendir.pending, (state)=> {
            state.isLoadingTeklifKabul = true
        })

        .addCase(surucuyuDegerlendir.fulfilled, (state, action)=> {
            state.isLoadingTeklifKabul = false
            state.tamamlananSeferlerList = state.tamamlananSeferlerList.map((item) => {
                if(item.waitinLoadId === action.payload.data.waitinLoadId){
                    return {
                        ...item, 
                        truckerUserRate: action.payload.data.truckerUserRate
                    }
                }else{
                    return item
                }
                
            })
        })

        .addCase(surucuyuDegerlendir.rejected, (state, action)=> {
            state.isLoadingTeklifKabul = false
        })

        
        .addCase(getAdminCompanyLoadFilter.pending, (state)=> {
            state.isLoadingSearch = true
        })
        .addCase(getAdminCompanyLoadFilter.fulfilled, (state, action)=> {
            state.isLoadingSearch = false
            state.loadListCompanyList = action.payload.$values
        })
        .addCase(getAdminCompanyLoadFilter.rejected, (state, action)=> {
            state.isLoadingSearch = false
            state.isErrorSearch = true
        })
    }
})


export const {
    setTopluYukErrorMessage,
    setLoadItemSelect,
    setLoadItemData,
    setCompleteShipmentIds,
    setShipmentContainerAndSealData,
    setShipmentActionData,
    resetShipmentVehicleOptions,
    updateLoadItem,
    getBelgeData,
    deleteSingleLoadItem,
    getBelgeDataSingleItem,
    setTeklifUserId,
    setTopPagesItemNotificationClicked,
    resetSingleShipmentLoadItem,
    setTopluYukSuccessMessage,
    setShipmentData,
    setSelectedLoadListCompany,
    updateLoadItemForPublishing,
    setSelectedAspiredLoadId,
    updateYuklemedeListForShipmentOperation
} = loadListSlice.actions
export default loadListSlice.reducer
